import Modal from "@mui/material/Modal";

export const SessionAboutToExpire = (props) => {
  return (
    <Modal open={true} onClose={props.close}>
      <div className="session-timeout-modal">
        Your session is about to expire. Do you want to continue ?
        <br />
        <button className="stm-btn" onClick={props.close}>
          Continue
        </button>
        <button className="stm-cancel" onClick={props.logout}>
          Logout
        </button>
      </div>
    </Modal>
  );
};

export const SessionExpired = (props) => {
  return (
    <Modal open={true} onClose={() => {}}>
      <div className="session-timeout-modal">
        Your session has expired due to inactivity. Please Log in again to
        continue.
        <br />
        <button className="stm-btn" onClick={props.logout}>
          Login
        </button>
      </div>
    </Modal>
  );
};
